module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-cfe34289.png";